import { render } from "./VisaCard.vue?vue&type=template&id=4167aad4"
import script from "./VisaCard.vue?vue&type=script&lang=js"
export * from "./VisaCard.vue?vue&type=script&lang=js"

import exportComponent from "C:\\wamp64\\www\\artware\\website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__